import { NAV_LINKS } from '@/config/nav'
import { cn } from '@/utils'
import { NavLink } from 'react-router-dom'

interface INavElement {
  path?: string
  onClick?: () => void
  text: string
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

const NavElement: React.FC<INavElement> = ({ path, text, icon: Icon, onClick }) => {
  if (onClick) {
    return (
      <button
        className="group flex cursor-pointer flex-row items-center gap-2 rounded-md p-2"
        onClick={onClick}
      >
        {Icon && (
          <Icon
            className={cn(
              'h-6 w-6',
              text === 'Zapisane grafiki'
                ? 'group-hover:[&>g>path:not(:nth-child(2))]:fill-primary'
                : 'group-hover:[&>g>path]:fill-primary'
            )}
          />
        )}
      </button>
    )
  }

  if (path) {
    return (
      <NavLink
        className={({ isActive }) =>
          cn(
            'group flex flex-row items-center gap-2 rounded-md p-2',
            isActive ? 'active-class' : 'inactive-class'
          )
        }
        to={path}
      >
        {Icon && (
          <Icon
            className={cn(
              'h-6 w-6',
              text === 'Zapisane grafiki'
                ? 'group-hover:[&>g>path:not(:nth-child(2))]:fill-primary'
                : 'group-hover:[&>g>path]:fill-primary'
            )}
          />
        )}
        <span className="hidden tracking-wide group-hover:text-primary md:block">
          {text}
        </span>
      </NavLink>
    )
  }
}

function Navigation() {
  return (
    <div className="flex flex-row items-center justify-between gap-8 md:gap-2">
      {NAV_LINKS.map((link, index) => (
        <NavElement
          icon={link.icon}
          key={'navEl_' + index}
          onClick={link.onClick}
          path={link.path}
          text={link.name}
        />
      ))}
    </div>
  )
}

export default Navigation
